module.exports = __webpack_public_path__ + "img/people_elements.27c364f0.svg";